<template>
  <div class="instructions">
    <p>Identify the hazards in each scene. Correct answers will be highlighted once tapped.</p>
    <img src="../assets/instructions_1.png" srcset="../assets/instructions_1.png 1x, ../assets/instructions_1@2x.png 2x, ../assets/instructions_1@3x.png" alt="Instructions">
    <Button text="Next" @click.native="goToInstructions2" />
  </div>
</template>

<script>
import Button from '@/components/Button.vue'

export default {
  components: {
    Button
  },
  methods: {
    goToInstructions2() {
      this.$router.push('/instructions-2')
    }
  }
}
</script>

<style lang="scss" scoped>
.instructions {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 75%;

  p {
    font-size: 27px;
    font-weight: bold;
    margin-bottom: 30px;
    margin-top: 0;
  }

  img {
    margin-bottom: 30px;
  }
}

@media (orientation: landscape) {
  .instructions {
    width: 90%;

    p {
      font-size: 21px;
      line-height: 30px;
      margin: 0 auto 15px;
    }

    img {
      display: block;
      margin: 20px auto;
      width: 150px;
    }
  }
}
</style>